import React, { useMemo, useState } from 'react'
import { Tabs } from '@base-ui/react/tabs'
import { MODULE_KEYS, MATCH_TABS_DEFAULTS, MatchTabsConfig } from '../../moduleRegistry'
import { useModuleConfig } from '../../hooks/useModuleConfig'
import { useMatchScreen } from '../../../context/MatchScreenContext'
import { trackEvent } from '../../../utils/tracking/mixpanel'
import { trackOptimizelyEvent } from '../../../utils/tracking/optimizely'
import { TabKey, TAB_REGISTRY, validateTabs } from './tabRegistry'

import '../../styles/MatchTabsModule/MatchTabsModule.scss'
import '../../styles/MatchTabsModule/Tabs.scss'

export const MatchTabsModule = () => {
  const config = useModuleConfig<MatchTabsConfig>(MODULE_KEYS.matchTabs, MATCH_TABS_DEFAULTS)
  const tabs = useMemo(() => validateTabs(config.tabs), [config.tabs])
  const { state: { pageKey } } = useMatchScreen()
  const [selected, setSelected] = useState<TabKey | null>(null)

  if (tabs.length === 0) return null

  const activeTab: TabKey = selected && tabs.some(t => t.key === selected) ? selected : tabs[0].key

  const handleValueChange = (next: TabKey) => {
    setSelected(next)
    const properties = { page_key: pageKey, action: TAB_REGISTRY[next].action }
    trackEvent('MatchScreen', 'handoff-faq-click', properties)
    trackOptimizelyEvent('handoff-faq-click', properties)
  }

  return (
    <Tabs.Root
      className="match-tabs-module"
      data-testid="match-tabs-module"
      value={activeTab}
      onValueChange={handleValueChange as (value: unknown) => void}
    >
      <Tabs.List className="match-tabs__tablist" aria-label="Match screen sections">
        {tabs.map(({ key, label }) => (
          <Tabs.Tab key={key} value={key} className="match-tabs__tab">
            <span>{label}</span>
          </Tabs.Tab>
        ))}
      </Tabs.List>
      {tabs.map(({ key }) => {
        const { Panel } = TAB_REGISTRY[key]
        return (
          <Tabs.Panel key={key} value={key} className="match-tabs__panel">
            <Panel />
          </Tabs.Panel>
        )
      })}
    </Tabs.Root>
  )
}
